export class MaritalStatus {
    StatusCode;
    CDesc;
    EDesc;
    constructor() {
        this.StatusCode = "";
        this.CDesc = "";
        this.EDesc = "";
    }
}



// WEBPACK FOOTER //
// ./src/model/MaritalStatus.js